import eventBus from '@/lib/eventBus';

export const confirm = {
  open(modal, ...params) {
    eventBus.$emit('confirm-open', modal, params);
  },
};

export function ConfirmSetup(app) {
  app.config.globalProperties.$confirm = confirm;
}